const CODE_ALIASES = {
    ESP: ['ESPECIAL']
};

function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export default function getKmlCodeFromPrefixo(
    prefixo,
    turnosCodesMap
) {

    const normalizedPrefixo = String(
        prefixo ?? ''
    ).trim().toUpperCase();

    if (!normalizedPrefixo) {
        return null;
    }

    for (const [code, kmlCode] of turnosCodesMap) {

        const codes = [
            code,
            ...(CODE_ALIASES[code] || [])
        ];

        for (const currentCode of codes) {

            let pattern;

            if (/^T\d$/.test(currentCode)) {

                pattern = new RegExp(
                    `(^|[\\s-])${escapeRegExp(currentCode)}([A-Z]|[\\s-]|$)`
                );

            } else if (
                ['MANHÃ', 'TARDE', 'NOITE'].includes(currentCode)
            ) {

                pattern = new RegExp(
                    `(^|[\\s-])${escapeRegExp(currentCode)}(?:\\s*-\\s*[ER])?($|[\\s-])`,
                    'u'
                );

            } else {

                pattern = new RegExp(
                    `(^|[\\s-])${escapeRegExp(currentCode)}($|[\\s-])`
                );

            }

            if (pattern.test(normalizedPrefixo)) {
                return kmlCode;
            }

        }

    }

    return null;
}